import { useMarketList } from '@/hooks/useMarketPlace';
import { InscriptionList } from './inscriptionList';
import { MarketPlaceItem } from './marketPlaceItem';
import { NFTProList } from './nftProList';
import styles from './index.module.scss';
import { Block } from '@/components/block';
import { useFm, useParams } from '@web3/base-hooks';
import { chaninId } from '@/utils/constant';

export const MarketPlace = () => {
  const { locale } = useParams();
  const fm = useFm();

  const { inscriptionList = [], nftProList = [] } = useMarketList({
    inscriptioinListParams: {
      limit: 4,
      start: 0,
      chainId: chaninId,
    },
    nftProListParams: {
      volumeBy: 3,
      from: 0,
      size: 4,
      chainCode: 'ETH',
    },
  });

  if (inscriptionList?.length <= 0 && nftProList?.length <= 0) {
    return;
  }

  return (
    <Block clsName={styles.marketplaceWrapper} noHeader>
      <div className={styles.marketplace}>
        <div className={styles.marketplace_title}>#{fm('marketPlace')}</div>
        <div className={styles.marketplace_body}>
          {inscriptionList?.length > 0 && (
            <MarketPlaceItem
              title={fm('Inscriptions')}
              jumpUrl={`/${locale}/web3/inscription`}
              appUrl="bybitapp://open/web3/inscription/home"
            >
              <InscriptionList list={inscriptionList} />
            </MarketPlaceItem>
          )}
          {nftProList?.length > 0 && (
            <MarketPlaceItem
              title={fm('nft_pro_name')}
              jumpUrl={`/${locale}/web3/nft-pro`}
              appUrl="bybitapp://open/web3/nft_pro"
            >
              <NFTProList list={nftProList} />
            </MarketPlaceItem>
          )}
        </div>
      </div>
    </Block>
  );
};
